import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Root.module.css';
import RootBottomSection from './components/RootBottomSection';
import RootTopSection from './components/RootTopSection';
import RootContent from './components/RootContent';

const bindClasses = classNameBind.bind(styles);

class Root extends React.Component {
  constructor(props) {
    super(props);
    const { title } = props;
    this.setTitle(title);
  }

  componentDidUpdate(prevProps) {
    const { title } = this.props;
    if (prevProps.title !== title) {
      this.setTitle(title);
    }
  }

  setTitle = (title) => {
    document.title = title;
  };

  render() {
    const { children } = this.props;

    return (
      <div
        className={bindClasses('wrapper')}
        data-ppuc-id="Root"
      >
        {children}
      </div>
    );
  }
}

Root.defaultProps = {
  title: 'Piwik PRO',
};

Root.BottomSection = RootBottomSection;
Root.Content = RootContent;
Root.TopSection = RootTopSection;

export default Root;
